export const collectionGrid = [
  3,6,3,4,4,
  3,4,4,6,3,
  4,3,3,6,4,
  3,4,4,3,6,
  3,4,4,6,3,
  4,3,3,6,4,
  3,4,4,3,6,
  3,6,3,4,4,
]